<script setup lang="ts">
  withDefaults(defineProps<{ active?: boolean }>(), { active: false })

  defineEmits<{ click: [event: MouseEvent] }>()
</script>

<template>
  <button type="button" class="filter-chip" :aria-pressed="active" @click="$emit('click', $event)">
    <slot />
  </button>
</template>

<style scoped lang="scss">
  /* Badges & chips (07) · OSCloud DS 1.1.154 — .filter-chip verbatim, DS tokens mapped to --bf-* / --dk-*. */
  .filter-chip {
    display: inline-flex;
    align-items: center;
    border: 1px solid var(--bf-line);
    border-radius: var(--bf-r-pill);
    padding: 3px 12px;
    font-family: var(--bf-font-display);
    font-size: var(--bf-fs-xs);
    font-weight: var(--bf-fw-medium);
    letter-spacing: 0.025em;
    background: var(--bf-white);
    color: var(--bf-fg-1);
    cursor: pointer;
    transition:
      background-color var(--dk-transition),
      border-color var(--dk-transition),
      color var(--dk-transition);

    &:hover {
      border-color: var(--bf-orange-dark);
      color: var(--bf-orange-dark);
    }

    &:focus-visible {
      outline: none;
      box-shadow:
        0 0 0 2px hsl(var(--dk-background)),
        0 0 0 4px hsl(var(--dk-ring));
    }

    /* A filter chip is a toggle button, so the selected state is its own aria-pressed
       rather than a parallel modifier class. */
    &[aria-pressed='true'] {
      background: hsl(var(--dk-primary));
      color: hsl(var(--dk-primary-foreground));
      border-color: transparent;

      &:hover {
        background: hsl(var(--dk-primary) / 0.8);
        color: hsl(var(--dk-primary-foreground));
        border-color: transparent;
      }
    }
  }
</style>
